import { EThemesOG } from '@/constants/themeConfig';
import { getThemeName } from '@/helpers/getThemeConfig';
import SignUp from './SignupNew';
import SignUpPageLegacy from './SignUpLegacy';

const themeName = getThemeName();

/**
 * Don't add to this list, use the Login import above
 */
const legacyBuildBookies = [
  EThemesOG.Wellbet,
  EThemesOG.Betgalaxy,
  EThemesOG.Questbet,
  EThemesOG.Betroyale,
  EThemesOG.Volcanobet,
  EThemesOG.Fiestabet,
  EThemesOG.Puntgenie,
  EThemesOG.Betprofessor,
];

export default legacyBuildBookies.includes(themeName)
  ? SignUpPageLegacy
  : SignUp;
